import { PulseFilters, pulseFiltersSchema } from './types'

import { api } from 'api'
import { z } from 'zod'

const spendPerWorkerTimeseriesResponse = z.array(
  z.object({
    shift_date: z.string(),
    avg_spend_per_worker: z.number(),
  })
)

export type SpendPerWorkerTimeseries = z.infer<
  typeof spendPerWorkerTimeseriesResponse
>

export async function getSpendPerWorkerTimeseries(
  filters: PulseFilters,
  signal?: AbortSignal
) {
  const data = pulseFiltersSchema.parse(filters)

  return await api
    .post('/company/pulse/cost/spend_per_worker_timeseries', data, { signal })
    .then((response) => response.data)
    .then(spendPerWorkerTimeseriesResponse.parse)
}

export async function getSpendPerWorkerTimeseriesCsv(
  filters: PulseFilters,
  signal?: AbortSignal
) {
  const data = pulseFiltersSchema.parse(filters)

  return await api
    .post('/company/pulse/cost/spend_per_worker_timeseries/csv', data, {
      signal,
    })
    .then((response) => response.data)
}
